import { Severity } from '../enums';

export interface BoxStatus {
  id: string;
  status: Severity;
}

export namespace BoxStatus {
  export function mapFromApiValue({ id, status }: any): BoxStatus {
    return {
      id,
      status: Severity.mapFromApiValue(status),
    };
  }
}
